import React from "react";
import PropTypes from "prop-types";
import { LocalizationSelect } from "./LocalizationSelect";
import { ContactUsLink } from "./ContactUsLink";

export const Header = ({logoUrl}) => (
  <header className={"h-16 min-w-full bg-primary-bg shadow-md sm:px-20 xs:px-10"}>
    <div className="flex items-center min-h-full">
      <img src={logoUrl} className="h-8 shrink filter-none dark:grayscale dark:brightness-[10]"/>
      <div className="grow">&nbsp;</div>
      <ContactUsLink />&nbsp;&nbsp;
      <LocalizationSelect />
    </div>
  </header>
);
Header.propTypes = {
  logoUrl: PropTypes.string.isRequired,
}
